import {
    FETCH_HOLDING_DATA_BEGIN,
    FETCH_HOLDING_DATA_SUCCESS,
    FETCH_HOLDING_DATA_FAILURE,
    FETCH_HOLDING_SUMMARY_BEGIN,
    FETCH_HOlDING_SUMMARY_SUCCESS,
    FETCH_HOLDING_SUMMARY_FAILURE,
    FETCH_HOLDING_TOPLONGGRIDDATA_BEGIN,
    FETCH_HOlDING_TOPLONGGRIDDATA_SUCCESS,
    FETCH_HOLDING_TOPLONGGRIDDATA_FAILURE,
    FETCH_HOLDING_SHORTLONGGRIDDATA_BEGIN,
    FETCH_HOLDING_SHORTLONGGRIDDATA_FAILURE,
    FETCH_HOLDING_SHORTLONGGRIDDATA_SUCCESS
} from '../constants/holding';

const initialState = {
    topLongHoldings: [],
    HoldingDate: {},
    isLoading: false,
    HoldingSummary: {},
    HoldingData: [],
    error: "",
    shortLongHolding: [],
    isShortLongLoading: true,
    errorLoadingShortLong: null
}


export const getHoldingsReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        //Fetch Holding summary 
        case FETCH_HOLDING_SUMMARY_BEGIN:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case FETCH_HOLDING_SUMMARY_FAILURE:
            return {
                ...state,
                isLoading: true,
                error: payload.error
            };
        case FETCH_HOlDING_SUMMARY_SUCCESS:
            return {
                ...state,
                isLoading: false,
                HoldingSummary: payload.HoldingSummary,
            };

        //Holding grid data 
        case FETCH_HOLDING_DATA_BEGIN:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case FETCH_HOLDING_DATA_FAILURE:
            return {
                ...state,
                isLoading: true,
                error: payload.error
            };
        case FETCH_HOLDING_DATA_SUCCESS:
            return {
                ...state,
                isLoading: false,
                HoldingData: payload.HoldingData
            };
        
        //Holding Top long grid data
        case FETCH_HOLDING_TOPLONGGRIDDATA_BEGIN:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case FETCH_HOLDING_TOPLONGGRIDDATA_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: payload.error
            };
        case FETCH_HOlDING_TOPLONGGRIDDATA_SUCCESS:
            return {
                ...state,
                topLongHoldings: payload.TopLongHolding,
                isLoading: false,
            };
         //Holding short long grid data
         case FETCH_HOLDING_SHORTLONGGRIDDATA_BEGIN:
            return {
                ...state,
                isShortLongLoading: true,
                errorLoadingShortLong: null,
            };
        case FETCH_HOLDING_SHORTLONGGRIDDATA_FAILURE:
            return {
                ...state,
                isShortLongLoading: true,
                errorLoadingShortLong: payload.error
            };
        case FETCH_HOLDING_SHORTLONGGRIDDATA_SUCCESS:
            return {
                ...state,
                shortLongHolding: payload.shortLongHolding,
                isShortLongLoading: false,
            };
        default:
            return state;
    }
}

export default getHoldingsReducer
